export default __webpack_public_path__ + "static/media/dieppe15.fe1f207b.jpg";